import { useMemo } from "react";

// 从 ColorSet 中提取 light/dark 颜色（兼容新旧格式）
export function extractColors(colorSet: any): { light: string; dark: string } {
  if (colorSet.light && colorSet.dark) {
    return { light: colorSet.light, dark: colorSet.dark };
  }
  if (colorSet.colors && colorSet.colors.length > 0) {
    const sorted = [...colorSet.colors].sort(
      (a: any, b: any) => a.offset - b.offset,
    );
    const lightStop = sorted.find((s: any) => s.offset <= 0.1) || sorted[0];
    const darkStop =
      sorted.find((s: any) => s.offset >= 0.9) || sorted[sorted.length - 1];
    return {
      light: lightStop?.color || "#ffffff",
      dark: darkStop?.color || "#000000",
    };
  }
  return { light: "#ffffff", dark: "#000000" };
}

// 颜色渐变预览组件（兼容新旧格式）
export function GradientPreview({ colorSet }: { colorSet: any }) {
  const { light, dark } = extractColors(colorSet);

  const gradientStyle = useMemo(
    () => ({
      background: `linear-gradient(to right, ${light} 0%, ${dark} 100%)`,
    }),
    [light, dark],
  );

  return <div className="w-full h-full rounded" style={gradientStyle} />;
}
